import { API } from "@/lib/api";

// Cookie-freies First-Party-Tracking. Session-ID liegt in sessionStorage (kein Cookie).
const sid = () => {
  try {
    let s = sessionStorage.getItem("gca_sid");
    if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("gca_sid", s); }
    return s;
  } catch { return ""; }
};

// UTM-Parameter beim ersten Aufruf sichern (bleiben für die Session erhalten).
const utm = () => {
  let saved = {};
  try { saved = JSON.parse(sessionStorage.getItem("gca_utm") || "{}"); } catch { saved = {}; }
  try {
    const p = new URLSearchParams(window.location.search);
    const cur = {};
    ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => { const v = p.get(k); if (v) cur[k] = v; });
    if (Object.keys(cur).length) { saved = { ...saved, ...cur }; sessionStorage.setItem("gca_utm", JSON.stringify(saved)); }
  } catch { /* noop */ }
  return saved;
};

const isPrivate = (path) => /^\/(admin|pro|pay|storno)/.test(path || window.location.pathname);

export const track = (event, extra = {}) => {
  try {
    if (isPrivate(extra.path)) return;
    const u = utm();
    const body = {
      event,
      path: extra.path || window.location.pathname,
      referrer: document.referrer || "",
      utm_source: u.utm_source || "", utm_medium: u.utm_medium || "", utm_campaign: u.utm_campaign || "",
      session_id: sid(),
      screen_w: window.innerWidth || 0,
      course_id: extra.course_id || "",
      course_name: extra.course_name || "",
    };
    const url = `${API}/track`;
    const payload = JSON.stringify(body);
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(() => {});
    }
  } catch { /* Tracking darf die App nie stören */ }
};

export const trackPageview = (path) => track("pageview", { path });
